import { gapi } from 'gapi-script';
import { useState } from 'react';
//import { useAuth } from '../context';
//import { useApp } from '../context/app';
import usePersistedState from './usePersistedState';
import { useAlert } from './useAlert';

// type ISaveEvent = {
//   summary: string;
//   description: string;
//   start: {
//     dateTime: Date;
//     timeZone: string;
//   };
//   end: {
//     dateTime: Date;
//     timeZone: string;
//   };
// };

interface IConferenceData {
  entryPoints: {
    uri: string;
  }[];
}

interface IDate {
  dateTime?: Date;
  timeZone?: string;
}
interface IEvents {
  id: string;
  summary?: string;
  start: IDate;
  end: IDate;
  conferenceData: IConferenceData;
}

const { REACT_APP_CHAVE_API_GOOGLE_CALENDAR } = process.env;
const { REACT_APP_CLIENTE_ID_GOOGLE_CALENDAR } = process.env;

export const useGoogleEvents = (currentDate: Date) => {
  const alert = useAlert();
  const [events, setEvents] = useState<IEvents[]>([]);

  const [isLoggedWithGoogle, setIsLoggedWithGoogle] = usePersistedState<boolean>(
    '@legalhub:isLoggedWithGoogle',
    false,
  );

  const signOut = () => {
    setIsLoggedWithGoogle(false);
    setEvents([]);
  };

  const getEvents = () => {
    const initiate = () => {
      gapi.client
        .init({
          apiKey: REACT_APP_CHAVE_API_GOOGLE_CALENDAR,
          clientId: REACT_APP_CLIENTE_ID_GOOGLE_CALENDAR,
          scope: 'https://www.googleapis.com/auth/calendar',
          discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
        })
        .then(async () => {
          try {
            const status = await gapi.auth2.getAuthInstance().isSignedIn.get();

            if (!status) {
              await gapi.auth2.getAuthInstance().signIn({ prompt: 'consent' });
            }

            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            const quantityDaysMonth = new Date(year, month, 0).getDate();
            const response = await gapi.client.request({
              path: `https://www.googleapis.com/calendar/v3/calendars/primary/events`,
              params: {
                timeMin: new Date(year, month, 1).toISOString(),
                timeMax: new Date(year, month, quantityDaysMonth).toISOString(),
                singleEvents: true,
                orderBy: 'startTime',
              },
            });
            alert.show({ type: 'success', message: 'Eventos buscados com sucesso...' });
            setEvents(response.result.items);
            setIsLoggedWithGoogle(true);
          } catch (error) {
            alert.show({ type: 'error', message: 'Erro ao buscar eventos!' });
          }
        });
    };

    gapi.load('client', initiate);
  };

  const saveEvent = (
    subjectEvent?: string,
    year?: number,
    month?: number,
    day?: number,
    hour?: number | null,
    minutes?: number,
  ) => {
    // Caso os valores sejam menores que 10, adiciona 0 antes do valor para padronizar com 2 casas decimais com a função 'pad'
    const monthPad = pad(month as number);
    const dayPad = pad(day as number);
    const hourPad = pad(hour as number);
    const minutePad = pad(minutes as number);

    // Concatena os valores para criação da data já padronizada
    const dateInitial = `${year}-${monthPad}-${dayPad}T${hourPad}:${minutePad}:00-03:00`;

    /* eslint-disable global-require */
    const moment = require('moment');

    const dateFinal = moment(dateInitial); // Converte a string da data padronizada para moment
    dateFinal.add(15, 'minutes'); // Adiciona 15 minutos na data para que cada evento tenha duração de 15 minutos

    const event = {
      summary: subjectEvent,
      // As datas precisam ser enviadas dessa maneira '2022-12-09T14:30:00-03:00'
      start: {
        dateTime: dateInitial, // Data inicial padronizada
        timeZone: 'America/Sao_Paulo',
      },
      end: {
        dateTime: dateFinal.format(), // Data final com o acrescimo de 15 minutos, que é o tempo de duração de cada evento
        timeZone: 'America/Sao_Paulo',
      },
    };

    const request = gapi.client.calendar.events.insert({
      calendarId: 'primary',
      resource: event,
    });

    request.execute(event);
  };

  const pad = (value: number) => {
    if (value < 10) {
      return `0${value}`;
    }
    return value.toString();
  };

  return { isLoggedWithGoogle, signOut, getEvents, saveEvent, events };
};
